import React from "react";
import { Link } from "react-router-dom";

export function HiveMark({ className = "w-9 h-9" }) {
  return <img src="/brand/mark.png" alt="" width="64" height="64" className={`${className} rounded-full select-none`} aria-hidden="true" draggable="false" />;
}

export function Wordmark({ className = "h-11 sm:h-12" }) {
  return (
    <picture>
      <source srcSet="/brand/logo.webp" type="image/webp" />
      <img src="/brand/logo.png" alt="Haven Hives" width="1400" height="715" className={`${className} w-auto select-none`} draggable="false" />
    </picture>
  );
}

export default function Logo() {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center group" aria-label="Haven Hives — home">
      <Wordmark className="h-9 sm:h-12 transition-opacity duration-300 group-hover:opacity-80" />
    </Link>
  );
}
